
export const inputTextLimit = 250;
export const nameInputLimit = 20;
export const inputDescLimit = 10000;